import { render, staticRenderFns } from "./mainHeader.vue?vue&type=template&id=820ed212&scoped=true&"
import script from "./mainHeader.vue?vue&type=script&lang=js&"
export * from "./mainHeader.vue?vue&type=script&lang=js&"
import style0 from "./mainHeader.vue?vue&type=style&index=0&id=820ed212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820ed212",
  null
  
)

export default component.exports